var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarkAsReadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M674-96 539-232l50-51 85 85 187-186 51 50L674-96ZM480-517l312-179H168l312 179Zm0 85L168-611v347h237l72 72H168q-29.7 0-50.85-21.16Q96-234.32 96-264.04v-432.24q0-29.72 21-51.22t51-20.5h624q30 1 51 21.86 21 20.85 21 50.14v208l-72 71v-194L480-432Zm0 0Zm0-85Zm0 84Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsReadIcon);
export default __webpack_public_path__ + "static/media/mark_as_read_icon.252c0ffa8567423094f440a092227242.svg";
export { ForwardRef as ReactComponent };